import { Switch, SwitchProps } from 'components/UI/Switch';

export type FormSwitchProps = Omit<SwitchProps, 'value'> & {
  value: boolean | string | number;
};

const FormSwitch = ({ value = false, ...props }: FormSwitchProps) => (
  <Switch {...props} isChecked={value === true || value === 'true' || value === 1} />
);

export { FormSwitch };
